import { TextField, Button, DialogActions, ThemeProvider, Dialog, DialogTitle, DialogContent } from "@mui/material";
import React, { useMemo } from "react";
import palette from "../../../../../../config/colorPalette";
import { clone } from "ramda";
import { getMuiTheme } from "../../../../../utils/utils";

const ModalSectionInfo = ({
  e,
  equipment,
  setEquipment,
  indexEquipment,
  indChan,
  substructureSectionDataToggle,
  setSubstructureSectionDataToggle,
  indSub,
  indexSection,
  intl,
}) => {
  const theme = useMemo(() => getMuiTheme(), []);
  const handleClose = (substructureSectionDataToggle, setSubstructureSectionDataToggle, indSub, indexSection) => {
    let newA = clone(substructureSectionDataToggle);
    newA[indSub][indexSection] = false;
    setSubstructureSectionDataToggle(newA);
  };

  return (
    <>
      <ThemeProvider theme={theme}>
        <Dialog
          maxWidth="lg"
          open={substructureSectionDataToggle[indSub][indexSection]}
          onClose={() =>
            handleClose(substructureSectionDataToggle, setSubstructureSectionDataToggle, indSub, indexSection)
          }
        >
          <DialogTitle style={{ fontSize: "x-large", color: palette.primary, fontWeight: "600" }}>
            {intl.formatMessage({ id: "sub" })} {indSub + 1}
          </DialogTitle>
          <DialogContent>
            <div style={{ marginTop: "2%" }}>
              <TextField
                id={`section_name_${indChan}_${indSub}_${indexSection}`}
                style={{ margin: "0 0.2rem 0.8rem", minWidth: 0, flex: "1 1 220px" }}
                defaultValue={e.channels[indChan].substructures[indSub].sections[indexSection]}
                onBlur={(ev) => {
                  const newEquipments = [...equipment];
                  const updatedEquipment = { ...newEquipments[indexEquipment] };
                  updatedEquipment.channels[indChan].substructures[indSub].sections[indexSection] = ev.target.value;
                  newEquipments[indexEquipment] = updatedEquipment;
                  setEquipment(newEquipments);
                }}
                variant="outlined"
                label={intl.formatMessage({ id: "section.name" })}
                required
              />
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              style={{ backgroundColor: palette.secondary, color: "white" }}
              onClick={() =>
                handleClose(substructureSectionDataToggle, setSubstructureSectionDataToggle, indSub, indexSection)
              }
            >
              {intl.formatMessage({ id: "accept" })}
            </Button>
          </DialogActions>
        </Dialog>
      </ThemeProvider>
    </>
  );
};

export default ModalSectionInfo;
